import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import ReferralShare from './ReferralShare'
import styled from 'styled-components'
import { refer_a_friend_event } from 'gtm/pushEvents'
import './ReferralShareModal.scss'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 16px;
`

const ReferralShareModal = ({ show, onHide, userId, entryPoint }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [show])

  useEffect(() => {
    if (show) {
      refer_a_friend_event({
        interaction: 'open',
        entry_point: entryPoint,
        share_surface: 'modal'
      })
    }
  }, [show, entryPoint])

  const handleHide = () => {
    refer_a_friend_event({
      interaction: 'close',
      entry_point: entryPoint,
      share_surface: 'modal'
    })
    onHide()
  }

  if (!show || !mounted) return null

  return ReactDOM.createPortal(
    <Overlay onClick={handleHide}>
      <div
        className='referral-share-modal__inner'
        onClick={(e) => e.stopPropagation()}
      >
        <ReferralShare
          userId={userId}
          isModal
          onClose={handleHide}
          entryPoint={entryPoint}
          shareSurface='modal'
        />
      </div>
    </Overlay>,
    document.body
  )
}

ReferralShareModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** GTM `entry_point`: footer | profile_menu | hamburger_menu | referral_page | unknown */
  entryPoint: PropTypes.string
}

ReferralShareModal.defaultProps = {
  entryPoint: 'unknown'
}

export default ReferralShareModal
